import { JurisdictionId } from 'types/jurisdiction/jurisdiction'

/**
 * TODO: the jurisdiction is currently resolved from a build-time env var.
 * Once the OS platform exposes it on `osContext`, this is the only place that
 * needs to change — every consumer goes through `jurisdictionConfig()`.
 */
const JURISDICTION: JurisdictionId = process.env.REACT_APP_JURISDICTION === 'CN' ? 'CN' : 'DEFAULT' // default-safe: unknown → DEFAULT

export const getJurisdiction = (): JurisdictionId => JURISDICTION
